export default __webpack_public_path__ + "static/media/card04.e13fc732.svg";